import { AdapterRegistry, Metamodel, IModel, ImportExportSettings, SnowflakeV2Source, SnowflakeV2LinkedService, SnowflakeV2TableDataset } from 'shell-models-lib';
import { Model } from 'app/model/backendmodel';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from '../../value.adapter';
import { SnowflakeSourceAdapter, snowflakeSourceAdapter } from './snowflake.copysource.adapter';
import { LookupActivity } from 'app/model/pipeline/lookup.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SnowflakeV2Source),
    asynchronous: true,
    adapts: {
        ...snowflakeSourceAdapter,
        treatDecimalAsString: '*'
    }
})
export class SnowflakeV2SourceAdapter extends SnowflakeSourceAdapter {
    protected override model(): IModel {
        return SnowflakeV2Source.MODEL;
    }
    protected override async _toResource(model: SnowflakeV2Source): Promise<Model.SnowflakeSourceV2> {
        const result: Model.SnowflakeSourceV2 = await super._toResource(model);
        if (model.exportSettings != null) {
            result.exportSettings.storageIntegration = ValueAdapter.toResource(model.exportSettings, ImportExportSettings.STORAGE_INTEGRATION) || undefined;
        }
        if (model.owner instanceof LookupActivity) {
            const sourceDataset = model.owner.sourceDataset as SnowflakeV2TableDataset | undefined;
            const isV11Source = sourceDataset?.version === '1.1';
            const isV11LinkedService = (sourceDataset?.linkedService as SnowflakeV2LinkedService | undefined)?.version === '1.1';
            result.treatDecimalAsString = isV11Source || isV11LinkedService
                ? ValueAdapter.toResource(model, SnowflakeV2Source.TREAT_DECIMAL_AS_STRING)
                : undefined;
        }
        return result;
    }
    protected override async _toModel(resource: Model.SnowflakeSourceV2, owner: CopyActivity | LookupActivity): Promise<SnowflakeV2Source> {
        const result = await super._toModel(resource, owner as CopyActivity) as SnowflakeV2Source;
        if (resource.exportSettings != null) {
            ValueAdapter.toModel(
                result.exportSettings,
                ImportExportSettings.STORAGE_INTEGRATION,
                resource.exportSettings.storageIntegration
            );
        }
        if (resource.treatDecimalAsString != null && owner instanceof LookupActivity) {
            ValueAdapter.toModel(result, SnowflakeV2Source.TREAT_DECIMAL_AS_STRING, resource.treatDecimalAsString);
        } else {
            result.treatDecimalAsString = undefined;
        }
        return result;
    }
}
